import DesignTokens from '@tableau/design-tokens';
import { TabStyles } from '@tableau/widgets';
import { style } from 'typestyle';

import { NORMAL_FONT_SIZE } from '~src/settings/styles/CommonStyles';
import { applyColor }from '~src/style/ColorService';

// PulseFeatureSection styles
export const subSettingsWrapper = style({
  display: 'flex',
});

// PulseDigestSchedule styles
export const digestStartTimeDropdownWrapperStyle = style({
  display: 'flex',
  marginBottom: TabStyles.Spacing.LargeSpace
});

export const digestStartTimeDropdownStyle = style({
  width: '188px'
});

export const timeZoneNameContainerStyle = style({
  alignContent: 'flex-end'
});

export const timeZoneNameStyle = style({
  height: '22px',
  display: 'flex',
  alignItems: 'center',
  padding: '1px',
  marginLeft: TabStyles.Spacing.LargeSpace
});

export const frequencyTableStyle = style({
  borderCollapse: 'collapse',
  width: '100%',
  marginTop: TabStyles.Spacing.MediumSpace,
  fontSize: NORMAL_FONT_SIZE,
  boxSizing: 'border-box'
});

export const tableHeaderStyle = style({
  borderBottom: '1px solid ' + applyColor(DesignTokens.color.elevation.border.default.medium, '#939393'),
  padding: '4px 24px',
  textAlign: 'left',
  fontWeight: 500,
  fontSize: NORMAL_FONT_SIZE,
  height: '32px',
  boxSizing: 'border-box'
});

export const tableCellStyle = style({
  borderBottom: '1px solid ' + applyColor(DesignTokens.color.elevation.surface.default.default, '#C9C9C9'),
  padding: '4px 24px',
  verticalAlign: 'middle',
  height: '32px',
  boxSizing: 'border-box'
});

export const alternateRowStyle = style({
  backgroundColor: applyColor(DesignTokens.color.elevation.surface.default.subtle, '#F3F3F3')
});

export const frequencyColumnStyle = style({
  minWidth: '200px',
  width: 'auto'
});

export const startTimeColumnStyle = style({
  minWidth: '350px',
  width: 'auto'
});

export const onColumnStyle = style({
  minWidth: '440px',
  width: 'auto'
});

export const tableDropdownStyle = style({
  width: '188px',
  height: '24px'
});

export const frequencyDescriptionStyle = style({
  marginTop: TabStyles.Spacing.ExtraLargeSpace
});

export const warningTextStyle = style({
  whiteSpace: 'nowrap'
});

export const slackIntegrationsInfoStyle = style({
  paddingLeft: '20px',
  marginTop: '6px'
});